import React from 'react';
import "./experience.css";

const Experience = () => {
  return (
    <section id='experience'><br/>
      <h2>My Experience</h2>

      <div className='container experience_container'>
        <article className='experience'>
          <div className='experience_head'>
            <h3>Practicum</h3>
            <h4>Robertson College</h4>
            <h5>Winnipeg, MB</h5>
            <h5>3 weeks, 120 hrs</h5>
          </div>
          <ul className='experience_list'>
            <li>
            <p>•	Login and Registration Page using JSP, JDBC, Servlet, and MySQL</p>
            </li>
            <li>
            <p>•	eCommerce website using React and deployed in Azure DevOps</p>
            </li>
            <p>•	To-do list Angular application and deployed in Netlify</p>
            <li></li>
            <li>
            <p>•	My Portfolio Dashboard website using React and deployed in Netlify</p>
            </li>    
          </ul>
        </article>
        <article className='experience'>
          <div className='experience_head'>
            <h3>Housekeeping Aide</h3>
            <h4>Health Science Center</h4>
            <h5>Winnipeg, MB</h5>
            <h5>February 2020 - present</h5>
          </div>
          <ul className='experience_list'>
            <li>
            <p>•	Cleaned floors daily and performed deep cleaning such as shampooing, waxing, and buffing regularly.</p>
            </li>
            <li>            
            <p>•	Maintained health standards by consistently cleaning high-traffic areas such as corridors, restrooms, and elevators. </p>
            </li>
            <li>
            <p>•	Performed special and routine cleaning and maintenance.</p>
            </li>    
          </ul>
        </article>
        <article className='experience'>
          <div className='experience_head'>
            <h3>Cashier</h3>
            <h4>Real Canadian Wholesale Club</h4>
            <h5>Winnipeg, MB</h5>
            <h5>October 2011 - March 2020</h5>
          </div>
          <ul className='experience_list'>
            <li>
            <p>•	Issue receipts, refunds, credits, or changes due to customers.</p>
            </li>
            <li>
            <p>•	Receive payment by cash, check, credit cards, vouchers, or automatic debits.</p>
            </li>
            <li>
            <p>•	Answer customers' questions, and provide information on procedures or policies.</p>
            </li>    
          </ul>
        </article>
        
         
      </div>
    </section>
  )
}

export default Experience